import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API, CONST_AWS_API, COUNTRIES_LIST, FEATURES_DATA } from 'src/app/core/constants';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { API as AWS_API } from 'aws-amplify';
import { ValidationService } from 'src/app/core/services/validation.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
declare let window: any;

@Component({
  selector: 'app-subscribe-payment',
  templateUrl: './subscribe-payment.component.html',
  styleUrls: ['./subscribe-payment.component.scss']
})
export class SubscribePaymentComponent implements OnInit {

  @Output('toggleSubscribeSideMenu') toggleSubscribeSideMenu: EventEmitter<any> = new EventEmitter();
  @Input('screenFrom') screenFrom: any = "";
  showCCForm: boolean = false;
  billingForm: FormGroup;
  address: string;
  pastedText: any;
  codes: any = {};
  currency: any;
  userInfo: any = {};
  loadCss = `${environment.CONSUMER_PORTAL}assets/custom-css/paystand.css`;
  card: any;
  cardError: string;
  validStripeForm = false;
  taxPercentage = 0;
  taxAmount = 0;
  taxable: boolean = true;
  finalAmount: any;
  invoice_id: any;
  incl: any;
  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  psKey: any;
  cardId: any;
  currentLocation: any;
  @Input('selectedPlan') selectedPlan: any = {};
  @Input('performer_details') performer_details: any = {};
  // Stream page's active side panel; unset elsewhere (e.g. subscription-list).
  @Input('activeBlock') activeBlock: string;
  // Organization for wallet-specific calls only: prefer the reliably-populated commanSubscribeService.orgId,
  // falling back to selectedPlan.organization_id (which isn't always set depending on how the plan was loaded).
  get walletOrgId() { return this.commanSubscribeService.orgId ?? this.selectedPlan?.organization_id; }
  reopen: boolean;
  isPaymentSuccess = false;
  ccForm: FormGroup;
  is_subscribe_charge_msg = false;
  FEATURES_DATA = FEATURES_DATA;
  countriesList = COUNTRIES_LIST;
  billingCountry: any = {};
  options: {};
  countryChanged: boolean = true;
  isEdit: boolean = false;
  paypalScript: any;
  selectedPlanAmount: any;
  selectedPlanCurrency: any;
  currentTheme: any;
  @Input('settingsData') settingsData: any = {};
  subTypeList: string;
  assets_url = environment.assets_url;
  selectedCard: any = {};
  selectedCardInfoSubscr: Subscription;
  showBillingForm: boolean = false;
  save_card: boolean = true;
  addressList: any = [];
  addressListInfoSubscr: Subscription;
  savedCardsListSubscr: Subscription;
  savedCardsList: any = [];
  newShippingForm: boolean = false;
  addNewCard: boolean = false;
  selectedBillingAddress: any;
  userInfoSubscription: Subscription;
  transactionInfoSubscr:Subscription;
  transactionInfo: any;
  currentBlock: any;
  billingAddress: any;
  formStatusSubscr: Subscription;
  selectedTransaction: any;
  albumUrl: String;
  USD_Rates : any;
  totalAmount : any;
  currency_for_totAmt : string;
  amt_without_pf : number;
  crypto_amount : number;
  sliced_crypto_amount : number;
  clientDetails : any;
  cryptoToken : any;
  cryptoSymbol : any;
  referral_code:string = null;

  constructor(private formBuilder: FormBuilder, private commanSubscribeService: CommanSubscribeService,
    private ngxLoader: NgxUiLoaderService, private storageService: StorageService,
    private activatedRoute: ActivatedRoute, private toastr: ToastrService, private appPaymentService: AppPaymentTVService,
    private loader: NgxUiLoaderService, private router: Router, private paymentService: PaymentService, private renderer: Renderer2) { }

  ngOnInit() {
    if(this.router.url.includes("?ref=")){
      this.referral_code = this.router.url.split("?ref=")[1];
    }
    this.currentBlock = "Subscribe";
    if (this.router.url.includes('subscribe-payment')) {
      this.screenFrom = "mobile";
    } else {
      this.screenFrom = "directive";
    }
    this.currentTheme = this.commanSubscribeService.getThemeColors();
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;
    this.commanSubscribeService.getCurrencyRates("USD",result=>{
      this.USD_Rates = result;
    });
    this.totalAmount = this.commanSubscribeService.getTotalAmount().subscribe(response => {
      this.currency_for_totAmt = response.currency;
      this.amt_without_pf = response.amt_without_pf;
      this.crypto_amount = this.commanSubscribeService.convertToCryptoAmount(this.amt_without_pf,this.USD_Rates[this.currency_for_totAmt])
      this.sliced_crypto_amount = Math.trunc(this.crypto_amount * Math.pow(10, 3))/Math.pow(10, 3);
    })

    this.formStatusSubscr = this.commanSubscribeService.getFormStatus().subscribe(response => {
      if(response){
        this.toggleSideMenuClose('close');
      }
    });

    this.savedCardsListSubscr = this.commanSubscribeService.getSavedCards().subscribe(response => {
      this.savedCardsList = response;
      if (this.savedCardsList.length == 0 && this.addressList.length > 0 && this.addressList.billingAddress.length == 0) {
        this.showBillingForm = true;
      } 
      if (this.savedCardsList.length == 0) {
        this.addNewCard = true;
      }
    })
    this.selectedCardInfoSubscr = this.commanSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
      if (response) {
        this.selectedBillingAddress = {};
        // this.buildBillingForm();
        this.showBillingForm = false;
        this.addNewCard = false;
        // let country;
        // COUNTRIES_LIST.forEach(element => {
        //   if (element.alpha2code == this.selectedCard.billing_address.country) {
        //     country = element;
        //   }
        // });
        // if (this.selectedCard && this.selectedCard.id) {
        //   let card = this.selectedCard.billing_address;
        //   this.selectedBillingAddress.line1 = card.line1;
        //   this.selectedBillingAddress.line2 = card.line2;
        //   this.selectedBillingAddress.city = card.city;
        //   this.selectedBillingAddress.country = card.country;
        //   this.selectedBillingAddress.state = card.state;
        //   this.selectedBillingAddress.zip = card.postal_code;
        // }
        // if (this.selectedTransaction == "ott") {
        //   this.commanSubscribeService.validateZip(this.selectedCard.billing_address.postal_code, country.name, (result) => {
        //     if (result.status) {
        //       this.codes = result;
        //       let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
        //       this.codes.country = country[0].alpha3code;
        //       this.getTaxPercentage(this.selectedCard.billing_address.postal_code, () => {

        //       });
        //     } else {
        //       this.toastr.error('Invalid zip code');
        //     }
        //   });
        // }
      }
    });

    this.addressListInfoSubscr = this.commanSubscribeService.getAddressList().subscribe(response => {
      this.addressList = response;
      if (this.addressList && this.addressList.billingAddress.length > 0) {
        let billingAdd = this.addressList.billingAddress.filter(a => a.billingAddress);
        this.showBillingForm = billingAdd.length > 0 ? true : false;
        if (this.showBillingForm) {
          this.commanSubscribeService.formsValidationSubject.next(false);
        }
        let selectedAddress = this.addressList.billingAddress.filter(a => a.defaultBillingAddress);
        this.billingAddress = this.selectedBillingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
        if(Object.keys(this.selectedBillingAddress).length > 0)
          this.commanSubscribeService.formsValidationSubject.next(true);
          this.buildBillingForm();
      } else if (this.addressList.billingAddress.length == 0 && this.savedCardsList.length == 0) {
        this.showBillingForm = true;
      }
    });

    this.transactionInfoSubscr = this.commanSubscribeService.getTransactionInfo().subscribe(response => {
      // transactionInfo is shared by every payment form; on the stream page this component stays
      // alive (CSS-hidden) after a plan is picked, so ignore payments made from other panels.
      if (this.activeBlock !== undefined && this.activeBlock !== 'Subscribe') return;
      this.transactionInfo = response;
      this.card = this.transactionInfo["card"];
      if (this.selectedCard && this.selectedCard.id) {
        this.makePayment('card');
      } else {
        this.makePayment();
      }
    })
    this.subTypeList = this.selectedPlan.subType;
    this.currentLocation = this.commanSubscribeService.locationInfo;
    this.selectedPlan.amount = this.selectedPlan.tier_amount;
    this.selectedPlanAmount = Number(this.selectedPlan.amount_after_dis_no_bf) + Number(this.selectedPlan.booking_fee);
    this.selectedPlanCurrency = this.selectedPlan.current_currency;
    if (this.selectedPlan.tier_amounts && typeof this.selectedPlan.tier_amounts === 'string') {
      this.selectedPlan.tier_amounts = JSON.parse(this.selectedPlan.tier_amounts);
    }
    if (this.router.url.includes('subscriptionForm')) {
      this.selectedPlan.plan_name = "Plan Name";
    }
    this.buildBillingForm();
    let locInfo = this.commanSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : {};
        } else {
          this.currentLocation = json;
        }
        this.prepare();
      });
    } else {
      this.prepare();
    }

    if (new Date().getTime() <= new Date(FEATURES_DATA.SUBSCRIBE_CHANNEL_APPLY_CHARGE).getTime()) {
      this.is_subscribe_charge_msg = true;
    }
    // if (!this.router.url.includes('subscriptionForm') && !this.router.url.includes('/preview')) {
    //   this.getPaymentMethods();
    // }
    this.commanSubscribeService.trackGoogleAnalytics('begin_checkout');
    this.commanSubscribeService.trackFBEvents('InitiateCheckout');
    if(this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.user_id && this.router.url.includes('/album/')){
      const groupName = this.activatedRoute.snapshot.params.groupName;
      this.albumUrl = environment.CONSUMER_PORTAL +this.activatedRoute.snapshot.params.channelName + (groupName ? '/' + groupName : '') + '/album/' + this.activatedRoute.snapshot.params.tag_category + '/' + this.activatedRoute.snapshot.params.slug_name + '?id='+this.activatedRoute.snapshot.queryParams.id;
    } else {
      this.albumUrl = environment.CONSUMER_PORTAL +this.activatedRoute.snapshot.params.pName + '/subscription-list';
    }
  }

  ngAfterViewInit() {
    const matWrapper = document.querySelector('.amount-field .mat-form-field-wrapper');

    if (matWrapper) {
      if (Object.keys(this.settingsData).length !== 0) {
        // Apply color dynamically
        this.renderer.setStyle(matWrapper, 'background', this.settingsData.form_font_secondary_color);
      }else{
        this.renderer.removeStyle(matWrapper, 'background');
      }
    }
    this.addStyle();
  }

  calFee(response) {
    console.log("this.currentBlock,",this.currentBlock)
    if (this.currentBlock== "Subscribe") {
      this.selectedTransaction = response.selectedTransaction;
      let amountWithBookingFee = Number(this.selectedPlan.amount_after_dis_no_bf) + Number(this.selectedPlan.booking_fee || 0);
      if (this.selectedTransaction == "wallet" || this.selectedTransaction == "crypto") {
        this.selectedPlan.processingFee = 0;
        this.finalAmount = amountWithBookingFee + this.taxAmount;
      } else if (this.selectedTransaction && this.selectedTransaction == "ott") {
        this.selectedPlan.processingFee = (amountWithBookingFee * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.selectedPlan.processingFee = Number(this.selectedPlan.processingFee.toFixed(2));
        this.finalAmount = amountWithBookingFee + Number(this.selectedPlan.processingFee) + Number(this.taxAmount);
      }
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.selectedPlan.current_currency,
        "processing_fee": this.selectedPlan.processingFee ? this.selectedPlan.processingFee : undefined,
        "amt_without_pf": this.taxAmount + amountWithBookingFee
      }
      this.commanSubscribeService.totalAmountSubject.next(data);
    }
  }

  // savedCardsList: any = [];
  getPaymentMethods() {
    const orgId = this.selectedPlan?.organization_id;
    const url = API.GET_PAYMENT_METODS + (orgId ? "?organization_id=" + orgId : "");
    this.appPaymentService.getRequest(url).subscribe(response => {
      if (response.status == 0) {
        let resp = response['result'];
        this.savedCardsList = [];
        let gateway = 'stripe';
        if (resp.length > 0) {
          if ((this.selectedPlan.current_currency != 'GBP' && this.selectedPlan.currency_type == 'USD') || this.selectedPlan.current_currency == 'USD') {
            gateway = 'stripeus';
          }
          resp.forEach(element => {
            if (element.payment_gateway == gateway) {
              this.savedCardsList.push(element);
            }
          });
          setTimeout(() => {
            let ele = document.querySelectorAll<HTMLElement>('.mat-radio-outer-circle');
            for (let i in ele)
              if (ele[i]) {
                if(this.settingsData){
                  ele[i].style.setProperty("borderColor",this.settingsData.font_secondary_color,"important");
                }
                else{
                  ele[i].style.setProperty("borderColor","","");
                }
              }
          }, 500)
        }
        if (this.savedCardsList.length == 0) {
          this.showBillingForm = true;
        }
      }
    }, error => {
      this.toastr.error(error.error);
    });
  }

  selectedCardInfo: any = {};
  selectCard(event, card) {
    this.selectedCard = card;
    let country;
    this.countriesList.forEach(element => {
      if (element.alpha2code == card.billing_address.country) {
        country = element;
      }
    });
    this.commanSubscribeService.validateZip(card.billing_address.postal_code, country.name, (result) => {
      if (result.status) {
        this.codes = result;
        let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
        this.codes.country = country[0].alpha3code;
        if (result.status) {
          this.getTaxPercentage(this.getBillingValue.zip, () => {

          });
        } else {
          this.toastr.error('Invalid zip code');
        }
      }
    });
  }

  newCard() {
    this.addNewCard = true;
    this.selectedCard = {};
    this.billingForm.enable();
    if (this.addressList.billingAddress.length == 0)
      this.showBillingForm = true;
    this.commanSubscribeService.selectedCardSubject.next(false);
  }

  // addNewCard() {
  //   this.showBillingForm = true;
  //   this.billingForm.enable();
  //   this.selectedCardInfo = {};
  // }

  buildBillingForm() {
    this.billingForm = this.formBuilder.group({
      amount: ["", Validators.required],
      address1: ["", Validators.required],
      address2: [""],
      city: ["", Validators.required],
      state: ["", Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(this.countriesList, 'name')]],
      zip: ["", Validators.required],
    });
    let amount = this.selectedPlan && this.selectedPlan.amount_after_dis_no_bf ? this.selectedPlan.amount_after_dis_no_bf : 0;
    if (amount) {
      amount = Number(amount).toFixed(2);
    }
    this.billingForm.patchValue({
      amount: amount
    });
    this.billingForm.get("amount").disable();
    // Now add validators after the form is initialized and values are set
    setTimeout(() => {
      this.billingForm.get('address1').setValidators(Validators.required);
      this.billingForm.get('city').setValidators(Validators.required);
      this.billingForm.get('state').setValidators(Validators.required);
      this.billingForm.get('country').setValidators([
        Validators.required,
        ValidationService.autoCompleteValueSelected(this.countriesList, 'name')
      ]);
      this.billingForm.get('zip').setValidators(Validators.required);
      // Update validity without marking as touched
      Object.keys(this.billingForm.controls).forEach(controlName => {
        const control = this.billingForm.get(controlName);
        control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      });
    });
    this.prepare();
  }

  buildCCForm() {
    this.ccForm = this.formBuilder.group({
      nameOnCard: ["", Validators.required],
      cardNumber: ["", Validators.required],
      expDate: ["", Validators.required],
      cvv: ["", Validators.required],
      month: [""],
      year: [""]
    });
  }

  toggleSideMenuClose(from) {
    if (this.screenFrom == "directive") {
      if (this.savedCardsList.length > 0 && this.showBillingForm) {
        this.showBillingForm = false;
        this.showCCForm = false;
      } else {
        this.toggleSubscribeSideMenu.emit(from);
      }
    }
  }

  get getCCValue() {
    return this.ccForm.getRawValue();
  }
  get getBillingValue() {
    return this.billingForm.getRawValue();
  }

  onPasteLocation(event: ClipboardEvent) {
    let clipboardData = event.clipboardData || window.clipboardData;
    this.pastedText = clipboardData.getData('text');
    this.getSelectedAddress(this.pastedText);
  }

  getSelectedAddress(val) {
    var myAddress = {
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      copy: false
    };
    let street = val && val.formatted_address ? val.formatted_address.split(',') : val.split(',');
    this.address = street[0];
    this.loader.start();
    if (val && val.formatted_address)
      val = val.formatted_address
    else
      val = this.pastedText;
    myAddress.address1 = this.address;
    if (val) {
      this.commanSubscribeService.getAddress(val, (result) => {
        this.loader.stop();
        if (result) {
          let place = {
            address_components: result['results'][0]['address_components'],
            geometry: result['results'][0].geometry
          }
          if (place && place.address_components) {
            place.address_components.forEach(element => {
              if ((element.types[0] == "sublocality_level_1" || element.types[0] == "premise") && element.long_name)
                myAddress.address2 = element.long_name;

              if ((element.types[0] == "locality" || element.types[0] == "postal_town") && element.long_name)
                myAddress.city = element.long_name;
              if ((element.types[0] == "administrative_area_level_1" || element.types[0] == "administrative_area_level_2") && element.long_name)
                myAddress.state = element.long_name;
              // if (element.types[0] == "country" && element.long_name)
              //   myAddress.country = element.long_name;
              if (element.types[0] == "postal_code" && element.long_name)
                myAddress.zip = element.long_name;
            });
          }
          this.billingForm.patchValue({
            address1: myAddress.address1 ? myAddress.address1 : this.address,
            address2: myAddress.address2,
            city: myAddress.city,
            state: myAddress.state,
            // country: myAddress.country,
            zip: myAddress.zip
          });

        }
      });
      // }).catch((error)=>{
      //   this.loader.stop();
      // });
    }
  }


  proceed(from?) {
    if (
      (this.billingForm.invalid && this.getBillingValue.zip === '') && 
      (
        (this.selectedCard && Object.keys(this.selectedCard).length === 0) || 
        this.selectedCard === null || 
        this.selectedCard === undefined
      ) && 
      (
        (this.selectedBillingAddress && Object.keys(this.selectedBillingAddress).length === 0) || 
        this.selectedBillingAddress === null || 
        this.selectedBillingAddress === undefined
      )
    ) {
      if (this.billingForm.invalid) {
        // Mark all fields as touched to show validation messages
        Object.keys(this.billingForm.controls).forEach(key => {
          this.billingForm.get(key).markAsTouched();
        });
      }
      this.toastr.error('Please enter complete billing address');
      return;
    }
    if (this.billingForm.valid || ((this.selectedCard && this.selectedCard.id) || (Object.keys(this.selectedBillingAddress).length > 0) || this.billingForm.valid)) {
      this.commanSubscribeService.billingInfoSubject.next(this.getBillingValue);
      this.commanSubscribeService.formsValidationSubject.next(true);
      if (from != 'card') {
        this.showBillingForm = false;
        this.showCCForm = true;
      }
      let country;
      if (this.selectedCard && this.selectedCard.id) {
        COUNTRIES_LIST.forEach(element => {
          if (element.alpha2code == this.selectedCard.billing_address.country) {
            country = element;
          }
        });
      }
      if (this.selectedCard && this.selectedCard.id) {
        let card = this.selectedCard.billing_address;
        this.selectedBillingAddress.line1 = card.line1;
        this.selectedBillingAddress.line2 = card.line2;
        this.selectedBillingAddress.city = card.city;
        this.selectedBillingAddress.country = card.country;
        this.selectedBillingAddress.state = card.state;
        this.selectedBillingAddress.zip = card.postal_code;
      }
      // this.validateZip((valid) => {
        let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
        let cName = this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? country ? country.name : this.selectedBillingAddress.country : ""
        this.commanSubscribeService.validateZip(zip, cName, (result) => {
        if (result.status) {
          this.isEdit = !this.isEdit;
          this.billingForm.disable();
          this.codes = result;
          let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
          this.codes.country = country[0].alpha3code;
          if (result.status) {
            this.getTaxPercentage(zip, () => {
              // this.showCCForm = true;
              if (from == 'card') {
                this.makePayment('card');
              }
            });
          } else {
            this.toastr.error('Invalid zip code');
          }
        }
      });
    }
  }

  getBillingField(billingKey, selectedKey = billingKey) {
    const billingVal = this.getBillingValue?.[billingKey];
    const selectedVal = this.selectedBillingAddress?.[selectedKey];
    if (billingVal !== undefined && billingVal !== null && billingVal !== "") {
      return billingVal;
    }
    if (selectedVal !== undefined && selectedVal !== null && selectedVal !== "") {
      return selectedVal;
    }
    return "";
  }
  
  getTaxPercentage(zip, callback) {
    let amount = Number(this.selectedPlan.amount_after_dis_no_bf);
    let data: any = {
      vod: true,
      amount: amount,
      paymentType: 'channel_subscription',
      currency: this.selectedPlanCurrency,
      address: {
        street1: this.getBillingField("address1", "line1"),
        city: this.getBillingField("city"),
        state: this.getBillingField("state"),
        state_code: this.codes?.state ?? this.selectedBillingAddress?.state_code ?? "",
        zip: this.getBillingField("zip"),
        country: this.getBillingField("city"),
        country_code: this.codes?.country ?? this.selectedBillingAddress?.country_code ?? ""
      }
    };
    this.paymentService.calculateTax(data, (result) => {
      if (result.status == 0) {
        console.log(result.data);
        this.taxPercentage = result.data.taxPercentage;
        this.taxAmount = result.data.tax;
        this.finalAmount = result.data.finalAmount;
        this.invoice_id = result.data.invoice_id;
        this.incl = result.data.incl;
        let data={
          "total_amount": result.data.tax + Number(this.selectedPlan.amount_after_dis_no_bf),
          "currency": this.selectedPlan.current_currency,
          "processing_fee": this.selectedPlan.processingFee,
          "amt_without_pf": this.taxAmount + Number(this.selectedPlan.amount_after_dis_no_bf)
        }
        if(this.selectedPlan.booking_fee){
          this.finalAmount = Number(this.finalAmount) + Number(this.selectedPlan.booking_fee);
        }
        this.commanSubscribeService.totalAmountSubject.next(data);
        callback();
      } else {
        this.toastr.error('Unable to get tax');
      }
    });
  }

  editAddress() {
    this.isEdit = !this.isEdit;
    this.showCCForm = false;
    this.showBillingForm = true;
    this.billingForm.enable();
  }

  prepare() {
    if (this.currentLocation) {
      this.countriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          this.countryChanged = false
          this.billingForm.patchValue({
            country: country
          });
          this.options = {
            types: [],
            componentRestrictions: { country: country.alpha2code }
          };
          setTimeout(() => { this.countryChanged = true });
        }
      });
    }

    if (this.router.url.includes('subscribe-payment')) {

      this.getUserInfo(callBack => {
        this.getSubscriptionList(callBack => {
          this.selectedPlan.amount = this.selectedPlan.tier_amount;
          if (this.selectedPlan.tier_amounts && typeof this.selectedPlan.tier_amounts === 'string') {
            this.selectedPlan.tier_amounts = JSON.parse(this.selectedPlan.tier_amounts);
            this.getPaymentDetails();
          }
        });
      });

    } else {
      this.userInfo = JSON.parse(JSON.stringify(this.commanSubscribeService.userInfo));
      this.userInfo = this.userInfo || {};
      this.getPaymentDetails();
    }
  }


  getSubscriptionList(callBack) {
    let reqData = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        channel_name: this.activatedRoute.snapshot.queryParamMap.get('channel_name'),
        user_id: this.activatedRoute.snapshot.queryParamMap.get('user_id'),
        channel_url: this.activatedRoute.snapshot.queryParamMap.get('channel_name')
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_CHANNEL_SUBSCRIPTION_PLANS, reqData).then(response => {
      this.ngxLoader.stop();
      if (response.data.message === "Success") {
        if (response.data.Data && response.data.Data[0] && response.data.Data[0].plans && response.data.Data[0].plans.subscriptionsData) {
          let subscriptionList = response.data.Data[0].plans.subscriptionsData || [];
          this.performer_details = response.data.Data[0].performer_details;
          subscriptionList.forEach(e => {
            if (e.id == this.activatedRoute.snapshot.queryParamMap.get('plan_id')) {
              this.selectedPlan = e;
            }
          });
        }
      }
      callBack();
    }).catch(error => {
      this.ngxLoader.stop();
      callBack();
    });
  }

  getUserInfo(callBack) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        "user_id": this.activatedRoute.snapshot.queryParamMap.get('user_id'),
        "organization_id": this.selectedPlan?.organization_id
      }
    }
    this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
      this.loader.stop();
      if (response.data.user) {
        response.data.user.access_token = response.data.user.session_token;
        this.userInfo = this.commanSubscribeService.userInfo = response.data.user;
        this.commanSubscribeService.sendUserInfo(this.userInfo);
      }
      callBack();
    }).catch(error => {
      this.loader.stop();
      callBack();
    });
  }


  getPaymentDetails() {

    let resObj: any = {};
    resObj.stream = {
      organization_id: this.selectedPlan.organization_id,
      amount: this.selectedPlanAmount,
      currency: this.selectedPlanCurrency,
      tier_amounts: this.selectedPlan.tier_amounts,
      performer_id: this.selectedPlan.performer_id,
      channel_name: this.performer_details.channel_name,
      currency_type: this.selectedPlanCurrency
    };


    resObj.status = 0;
    resObj.message = "Success";
    if (this.currentLocation) {
      let tier_amounts = this.selectedPlan.tier_amounts || [];
      let foundCurrency: any = "";
      if (tier_amounts && tier_amounts.length > 0) {
        tier_amounts.forEach(e => {
          if (this.currentLocation.currency && e.currency_type && e.currency_type == this.currentLocation.currency.code) {
            foundCurrency = e;
          }
        });
      }

      if (foundCurrency) {
        this.selectedPlan.currency_type = foundCurrency.currency_type;
        this.selectedPlan.amount = foundCurrency.payment_amount;
      }
      this.finalAmount = this.selectedPlanAmount;
    }


    this.buildCCForm();
    let amount = this.selectedPlan && this.selectedPlan.amount_after_dis_no_bf ? this.selectedPlan.amount_after_dis_no_bf : 0;
    if (amount) {
      amount = Number(amount).toFixed(2);
    }
    this.billingForm.patchValue({
      amount: amount
    });
    this.billingForm.get("amount").disable();
  }

  selectCountry(country) {
    this.countryChanged = false
    this.billingCountry = country.value;
    this.options = {
      types: [],
      componentRestrictions: { country: country.value.alpha2code }
    };
    this.billingForm.patchValue({
      address1: "",
      address2: "",
      city: "",
      state: "",
      // country: "",
      zip: ""
    });
    setTimeout(() => { this.countryChanged = true });
  }

  displayCountryName(option) {
    return option ? option.name : undefined;
  }

  filterCountry() {
    if (this.getBillingValue.country) {
      let countriesList = JSON.parse(JSON.stringify(COUNTRIES_LIST));
      const filterValue = this.getBillingValue.country.toLowerCase();
      this.countriesList = countriesList.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
    } else {
      this.countriesList = [];
    }
  }

  toggleLoader(state) {
    var overlay = document.getElementsByClassName('ngx-overlay');
    overlay[0]['style'].display = state;
    if (state == 'none') {
      this.loader.stop();
    }
  }


  async makePayment(from?) {
    let amount, finalAmount, name;
    name = this.userInfo.user_display_name || this.userInfo.display_name
    amount = finalAmount = this.finalAmount;

    if (this.transactionInfo["card"] || from == 'card' || this.transactionInfo["mode"]) {
      let data: any = {
        amount: this.selectedTransaction == "crypto" ? this.crypto_amount : this.selectedPlan.amount_after_dis_no_bf,
        finalAmount: this.selectedTransaction == "crypto" ? this.crypto_amount : finalAmount,
        currency: this.transactionInfo.currency ? this.transactionInfo.currency : this.selectedPlanCurrency ? this.selectedPlanCurrency.toLowerCase() : 'gbp',
        // Only when actually paying via wallet does this prefer walletOrgId (commanSubscribeService.orgId
        // fallback); card/crypto payments keep the original organization_id source unchanged.
        organization_id: this.selectedTransaction == 'wallet'
          ? (this.walletOrgId ?? this.selectedPlan.organization_id)
          : this.selectedPlan.organization_id,
        performer_id: JSON.stringify(this.selectedPlan.performer_id),
        tier_amount_mode: this.selectedPlan.tier_amount_mode,
        discount_percentage: this.selectedPlan.discount_val,
        response: null,
        name: name,
        plan_id: this.selectedPlan.id,
        channel_id: this.selectedPlan.channel_id ? this.selectedPlan.channel_id : 0,
        channel_name: this.performer_details.channel_display_name,
        channel_url: this.performer_details.channel_name,
        zip : this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "",
        invoice_id: this.invoice_id,
        tax_amount: this.taxAmount,
        tax_rate: this.taxPercentage,
        creator_currency: this.selectedPlan.currency_type,
        processing_fee: this.selectedPlan.processingFee,
        sub_channel_url: this.activatedRoute.snapshot.params.sub_channel_name ? this.settingsData.channelInfo.channel_name : '',
        sub_channel_name: this.activatedRoute.snapshot.params.sub_channel_name ? this.settingsData.channelInfo.channel_display_name : '',
        benefits: this.selectedPlan.new_benefits,
        booking_fee: this.selectedPlan.booking_fee,
        network_group_id: this.selectedPlan?.network_group_id || ''
      };
      data['address'] = {
        street1: this.getBillingField("address1", "line1"),
        city: this.getBillingField("city"),
        state: this.getBillingField("state"),
        state_code: this.codes?.state ?? this.selectedBillingAddress?.state_code ?? "",
        zip: this.getBillingField("zip"),
        country: this.getBillingField("country"),
        country_code: this.codes?.country ??
                this.selectedBillingAddress?.country_code ??
                "",
      };
      data.channel_id = this.selectedPlan.channel_id ? this.selectedPlan.channel_id : 0;
      let billingAddress = {
        'line1': this.getBillingValue.address1,
        'line2': this.getBillingValue.address2 ,
        'city': this.getBillingValue.city,
        'state': this.getBillingValue.state,
        'country': this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : "",
        'postal_code': this.getBillingValue.zip
      }
      let cardInfo = {
        'card': this.card,
        'billing_details': {
          'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          'address': billingAddress
        }
      }
      if(this.transactionInfo['mode'] == 'wallet' || this.transactionInfo["mode"] == 'crypto'){
        this.completeTransaction(data,this.transactionInfo['paymentIntent']);
        return;
      }
      this.appPaymentService.postRequest(API.GET_STRIPE_SECRET, data).subscribe(result => {
        if (result['status'] == 0) {
          this.loader.start();
          this.transactionInfo.stripe.confirmCardPayment(result['client_secret'], {
            payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
          }).then((result) => {
            this.loader.stop();
            if (result.error) {
              // Show error to your customer (e.g., insufficient funds)
              this.toastr.error(result.error.message);
              console.log('payment_failed');
              this.commanSubscribeService.updatePaymentBtnSubject.next(true);
              this.commanSubscribeService.trackGoogleAnalytics('payment_failed');
            } else {
              if (result.paymentIntent.status === 'succeeded') {
                this.completeTransaction(data,result.paymentIntent);
              }
            }
          });
        } else {
          this.toastr.error(result.message)
          this.loader.stop();
        }
      }, error => {
      });
    } else if (!this.cardError) {
      this.cardError = "Please fill all the fields";
    }
  }

  isMobileAPP:boolean = false;
  completeTransaction(data, result) {
    data.response = result;
    data.id = result ? result.payment_method : undefined;
    data["gateway"] = this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : "stripe";
    data["transaction_amount"] = this.transactionInfo['transaction_amount'];
    data["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    data["referral_code"] = this.referral_code;
    
    // Fix for the JSON.parse error
    if((data['referral_code'] === undefined || data["referral_code"] === null)) {
      const affiliateReferralCode = localStorage.getItem('affiliateReferralCode');
      if (affiliateReferralCode && affiliateReferralCode !== 'undefined') {
        try {
          data['referral_code'] = JSON.parse(affiliateReferralCode);
        } catch (e) {
          console.error('Error parsing affiliateReferralCode from localStorage:', e);
          data['referral_code'] = null;
        }
      }
    }
    data['exchange_rate'] = this.USD_Rates[this.selectedPlanCurrency];
    this.appPaymentService.postRequest(API.SUBSCRIBE_CHANNEL, data).subscribe(result => {
      if (result['message'] == 'Success') {
        this.toastr.success("Subscribed successfully");
        this.isPaymentSuccess = true;
        if(this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.user_id){
          this.isMobileAPP = true;
          return;
        }
        this.appPaymentService.getRequestWithParams(API.GET_WALLET, { organization_id: String(this.walletOrgId || '') }).subscribe(response => {
          if (response.status == 0) {
            this.commanSubscribeService.walletByOrg[this.walletOrgId] = response.wallet;
            this.commanSubscribeService.walletInfoSubject.next({ organizationId: this.walletOrgId, wallet: response.wallet });
          }
        }, error => {
          this.toastr.error(error.error);
        });
        let amount = { value: this.finalAmount, currency: this.selectedPlanCurrency ? this.selectedPlanCurrency.toUpperCase() : 'GBP' }
        this.commanSubscribeService.trackGoogleAnalytics('purchase', amount);
        this.commanSubscribeService.trackFBEvents('Subscribe', amount);
        // try {fbq('track', 'Subscribe', {value: finalAmount, currency: this.selectedPlanCurrency ? this.selectedPlanCurrency.toLowerCase() : 'gbp'});} catch (e) { }
        this.isPaymentSuccess = true;
        this.backToLastPage();
        this.toggleSideMenuClose("success");
      } else {
        this.toastr.error(result['message']);
      }
    });
  }

  backToLastPage() {
    if (this.screenFrom == "directive" && this.activatedRoute.snapshot.queryParams.returnUrl) {
      this.router.navigate([this.activatedRoute.snapshot.queryParams.returnUrl]);
    }
  }

  addStyle(){
    const dynamicColor = this.settingsData?.form_font_secondary_color;
    document.documentElement.style.setProperty('--invalid-border-color', dynamicColor);
    document.documentElement.style.setProperty('--before-border-color', dynamicColor);

    //mat-select-dropdown
    document.documentElement.style.setProperty('--select-panel-bg', this.settingsData?.form_bg_primary_color);
    document.documentElement.style.setProperty('--select-panel-text', this.settingsData?.form_font_secondary_color);
    document.documentElement.style.setProperty('--select-panel-text-color', this.settingsData?.form_font_secondary_color);
    document.documentElement.style.setProperty('--select-panel-text-hover', this.settingsData?.font_secondary_color);
    //dropdown selected value
    document.documentElement.style.setProperty('--select-value-text', this.settingsData?.form_font_secondary_color);
  }

  ngOnDestroy() {
    this.card = '';
    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe();
    }
    if (this.addressListInfoSubscr) {
      this.addressListInfoSubscr.unsubscribe();
    }
    if (this.savedCardsListSubscr) {
      this.savedCardsListSubscr.unsubscribe();
    }
    if(this.userInfoSubscription){
      this.userInfoSubscription.unsubscribe();
    }
    if(this.formStatusSubscr){
      this.formStatusSubscr.unsubscribe();
    }
    if(this.transactionInfoSubscr){
      this.transactionInfoSubscr.unsubscribe();
    }
  }


}
